import affiliate from './affiliate'
import appbar from './appbar'
import auth from './auth'
import externalGame from './externalGame'
import sidebarItems from './sidebarItems'
import templateNumberType from './templateNumberType'
import userProfile from './userProfile'

export default {
  affiliate,
  appbar,
  auth,
  externalGame,
  sidebarItems,
  templateNumberType,
  userProfile
}